import {
    HIGHLIGHT_POSSIBLE_RESPONSE, SET_QUESTIONS_STATE,
    SELECT_POSSIBLE_RESPONSE, MAKE_FIRST_ATTEMPT,
    RESET_QUESTIONS_STATE, RESET_SELECTED_RESPONSE_INDEX, RESET_SELECTED_MULTI_CHOICE_INDEXES,
    ACTIVATE_READY_FOR_NEXT_SCREEN, START_RESPONSE_PLAYING, STOP_RESPONSE_PLAYING,
    SELECT_CLASSIFIED_RESPONSES, SELECT_MULTIPLE_RESPONSES, RESET_CLASSIFIED_RESPONSES,
    SET_IS_QUESTION_COMPLETED,
} from './questionsActions';
import { DEACTIVATE_READY_FOR_NEXT_SCREEN } from '../screen/screenActions';

export const defaultState = {
    itemId: undefined,
    selectedIndex: undefined,
    multiChoiceResponses: [],
    instructions: {},
    isFirstAttemptMade: false,
    isGreyedOut: false,
    isReadyForNextScreen: false,
    isResponsePlaying: false,
    classifiedResponses: undefined,
    questionCompleteness: [],
};

const questionsReducer = (state = defaultState, action) => {
    switch (action.type) {
    case HIGHLIGHT_POSSIBLE_RESPONSE:
        return {
            ...state,
            selectedIndex: action.index,
        };
    case SELECT_POSSIBLE_RESPONSE:
        return {
            ...state,
            isFirstAttemptMade: true,
            selectedIndex: action.index,
        };
    case SELECT_MULTIPLE_RESPONSES:
        return {
            ...state,
            multiChoiceResponses: action.responseIndexes,
        };
    case MAKE_FIRST_ATTEMPT:
        return {
            ...state,
            isFirstAttemptMade: true,
        };
    case RESET_SELECTED_RESPONSE_INDEX:
        return {
            ...state,
            selectedIndex: undefined,
        };
    case RESET_SELECTED_MULTI_CHOICE_INDEXES:
        return {
            ...state,
            multiChoiceResponses: [],
        };
    case SET_QUESTIONS_STATE:
        return {
            ...state,
            ...action.questionsState,
        };
    case ACTIVATE_READY_FOR_NEXT_SCREEN:
        return {
            ...state,
            isReadyForNextScreen: true,
        };
    case DEACTIVATE_READY_FOR_NEXT_SCREEN:
        return {
            ...state,
            isReadyForNextScreen: false,
        };
    case START_RESPONSE_PLAYING:
        return {
            ...state,
            isResponsePlaying: true,
            playingResponseIndex: action.index,
        };
    case STOP_RESPONSE_PLAYING:
        return {
            ...state,
            isResponsePlaying: false,
            playingResponseIndex: undefined,
        };
    case SELECT_CLASSIFIED_RESPONSES:
        return {
            ...state,
            classifiedResponses: action.classifiedResponses,
        };
    case SET_IS_QUESTION_COMPLETED:
        return {
            ...state,
            questionCompleteness: {
                ...state.questionCompleteness,
                [action.questionIndex]: action.isQuestionCompleted,
            },
        };
    case RESET_CLASSIFIED_RESPONSES:
        return {
            ...state,
            classifiedResponses: [],
        };
    case RESET_QUESTIONS_STATE:
        return defaultState;
    default:
        return state;
    }
};

export default questionsReducer;
